<template>
  <div v-if="!loader" class="attendance column label wrap">
    <div class="item column" v-for="(at, index) in content" :key="'attendance'+index">
      <div class="title row" @click="show(index)">
        <div class="grid">Atendimento A{{at.id}}</div>
        <i class="fa fa-chevron-down"></i>
      </div>
      <transition name="slide">
        <div class="content" v-if="content[index].show">
          <div class="row column-s wrap">
            <div class="grid-6 grid-12-s column">
              <span>Nome</span>
              {{at.nome_doutor}}
            </div>
            <div class="grid-7 grid-12-s column">
              <span>E-mail</span>
              {{at.email_doutor}}
            </div>
          </div>
          <div class="row column-s margin_top-20">
            <div class="grid-4 grid-12-s column">
              <span>Status</span>
              {{at.status}}
            </div>
            <div class="grid-4 grid-12-s  column">
              <span>Encerrado</span>
              {{ at.dh_encerramento && new Date(at.dh_encerramento).toLocaleString().substr(0,16) }}
            </div>
            <div class="grid-4 column">
              <span>Duração</span>
              {{at.duracao_atendimento}}
            </div>
          </div>
          <div class="divider margin_top-20"></div>
          <div class="column margin_top-20">
            <div class="purple">Arquivos</div>
            <div class="file" v-for="(file, i) in at.arquivos" :key="'file'+i">
              <a :href="file.link" target="_blank">
                <i class="fa fa-file"></i>
                {{file.descricao}}
              </a>
            </div>
          </div>
          <div class="divider margin_top-20"></div>
          <div class="column margin_top-20">
            <div class="purple">Descrição do Atendimento</div>
            <div class="desc">{{at.descricao_atendimento}}</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
  <div v-else class="loader-container column align-center justify-center">
    <Loader />
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.attendance {
  color: $gray-6;
  padding: 10px 10px;
  padding-top: 25px;
  padding-bottom: 25px;
  @media (min-width: $small) {
    width: 600px;
  }
  .margin_top-20 {
    margin-top: 20px;
  }
  .divider {
    margin-top: 35px;
  }
  button {
    margin-top: 55px;
  }
  strong {
    font-weight: 500;
    color: $gray-1;
  }
  .item {
    background: $white-8;

    border-radius: 5px;
    margin-bottom: 15px;
    .title {
      font-weight: 500;
      font-size: 17px;
      cursor: pointer;
      padding: 23px 27px;
      
      &:hover {
        background: $white-1;
      }
    }
    .content {
      padding: 0px 27px;
      font-size: 15px;
      font-weight: 500;
      padding-top: 20px;
      border-top: 1px solid $white-1;
      [class^="grid-"]{
        margin-top:20px;
      }
      span, .purple {
        font-weight: normal;
        color: $purple;
      }
      .file {
        &:hover {
          color: $green-1;
        }
        i {
          margin-right: 5px;
          margin-top: 15px;
        }
      }
      .desc{
        margin-top: 8px;
        margin-bottom: 15px;
      }
    }
  }
}
.loader-container {
  margin-top: 40px;
  padding: 30px;
}
</style>

<script>
import Loader from "@/components/Loader";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Attendance",
  props: {
    modal: Object
  },
  components: {
    Loader
  },
  data() {
    return {
      content: {},
      loader: true
    };
  },
  methods: {
    ...mapActions("job", ["LOAD_ATTENDANCE"]),
    ...mapGetters("job", ["GET_JOB"]),
    show(index) {
      this.content[index].show = !this.content[index].show;
      this.$forceUpdate();
    }
  },
  beforeMount() {
    const job = this.GET_JOB();
    if (job.id) {
      this.LOAD_ATTENDANCE(job.id).then(result => {
        this.content = result;
        for (let i in this.content) {
          this.content[i].show = false;
        }
        this.loader = false;
      });
    } else {
      this.loader = false;
    }
  }
};
</script>
